// src/components/report-forms/InformeGenericoForm.js
import React from 'react';
import { PlusCircleIcon, TrashIcon } from '@heroicons/react/24/outline';

const InformeGenericoForm = ({ formData, setFormData }) => {

    const updateField = (field, value) => setFormData(prev => ({ ...prev, [field]: value }));

    // Secciones dinámicas
    const sections = formData.sections || [{ titulo: '', contenido: '' }];
    const updateSection = (index, field, value) => {
        const updated = [...sections];
        updated[index] = { ...updated[index], [field]: value };
        setFormData(prev => ({ ...prev, sections: updated }));
    };
    const addSection = () => setFormData(prev => ({ ...prev, sections: [...(prev.sections || []), { titulo: '', contenido: '' }] }));
    const removeSection = (index) => setFormData(prev => ({ ...prev, sections: prev.sections.filter((_, i) => i !== index) }));

    return (
        <div className="space-y-6">
            {/* Datos del Proyecto */}
            <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg border border-transparent dark:border-gray-700">
                <h2 className="text-xl font-semibold mb-4 border-b dark:border-gray-700 pb-2 text-gray-700 dark:text-gray-200">I. Datos del Proyecto</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="md:col-span-2">
                        <label className="block text-sm font-medium dark:text-gray-300">Título del Informe *</label>
                        <input type="text" value={formData.titulo || ''} onChange={e => updateField('titulo', e.target.value)} className="w-full border dark:border-gray-600 rounded p-2 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100" required placeholder="Ej: Informe de Mantención Tablero Eléctrico" />
                    </div>
                    <div>
                        <label className="block text-sm font-medium dark:text-gray-300">Ubicación / Dirección</label>
                        <input type="text" value={formData.ubicacion || ''} onChange={e => updateField('ubicacion', e.target.value)} className="w-full border dark:border-gray-600 rounded p-2 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100" />
                    </div>
                    <div>
                        <label className="block text-sm font-medium dark:text-gray-300">Fecha</label>
                        <input type="date" value={formData.fecha || new Date().toISOString().split('T')[0]} onChange={e => updateField('fecha', e.target.value)} className="w-full border dark:border-gray-600 rounded p-2 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100" />
                    </div>
                </div>
            </div>

            {/* Antecedentes */}
            <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg border border-transparent dark:border-gray-700">
                <h2 className="text-xl font-semibold mb-4 border-b dark:border-gray-700 pb-2 text-gray-700 dark:text-gray-200">II. Antecedentes</h2>
                <textarea value={formData.antecedentes || ''} onChange={e => updateField('antecedentes', e.target.value)} rows="4" className="w-full border dark:border-gray-600 rounded p-2 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100" placeholder="Describa los antecedentes generales del informe..." />
            </div>

            {/* Secciones Dinámicas */}
            <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg border border-transparent dark:border-gray-700">
                <h2 className="text-xl font-semibold mb-4 border-b dark:border-gray-700 pb-2 text-gray-700 dark:text-gray-200">III. Contenido del Informe</h2>
                <p className="text-xs text-gray-500 dark:text-gray-400 mb-4">Agregue tantas secciones como necesite. Cada sección tendrá un título y contenido.</p>
                <div className="space-y-4">
                    {sections.map((section, index) => (
                        <div key={index} className="border dark:border-gray-600 rounded-lg p-4 bg-gray-50 dark:bg-gray-700/50 relative group">
                            <div className="flex justify-between items-center mb-2">
                                <span className="text-xs font-bold text-blue-600 dark:text-blue-400">Sección {index + 1}</span>
                                {sections.length > 1 && (
                                    <button type="button" onClick={() => removeSection(index)} className="text-red-500 hover:text-red-700 p-1"><TrashIcon className="w-4 h-4" /></button>
                                )}
                            </div>
                            <input
                                type="text"
                                value={section.titulo}
                                onChange={e => updateSection(index, 'titulo', e.target.value)}
                                className="w-full border dark:border-gray-600 rounded p-2 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 mb-2 font-semibold"
                                placeholder="Título de la sección"
                            />
                            <textarea
                                value={section.contenido}
                                onChange={e => updateSection(index, 'contenido', e.target.value)}
                                rows="4"
                                className="w-full border dark:border-gray-600 rounded p-2 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                                placeholder="Contenido de la sección..."
                            />
                        </div>
                    ))}
                </div>
                <button type="button" onClick={addSection} className="mt-4 text-blue-600 dark:text-blue-400 text-sm font-semibold hover:underline flex items-center gap-1">
                    <PlusCircleIcon className="w-4 h-4" /> Agregar Sección
                </button>
            </div>

            {/* Conclusiones */}
            <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg border border-transparent dark:border-gray-700">
                <h2 className="text-xl font-semibold mb-4 border-b dark:border-gray-700 pb-2 text-gray-700 dark:text-gray-200">IV. Conclusiones y Recomendaciones</h2>
                <div className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium dark:text-gray-300">Conclusiones</label>
                        <textarea value={formData.conclusiones || ''} onChange={e => updateField('conclusiones', e.target.value)} rows="3" className="w-full border dark:border-gray-600 rounded p-2 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100" placeholder="Conclusión general del informe..." />
                    </div>
                    <div>
                        <label className="block text-sm font-medium dark:text-gray-300">Recomendaciones</label>
                        <textarea value={formData.recomendaciones || ''} onChange={e => updateField('recomendaciones', e.target.value)} rows="3" className="w-full border dark:border-gray-600 rounded p-2 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100" placeholder="Recomendaciones técnicas..." />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InformeGenericoForm;
